import careerpage from '../views/Careerpage.vue';
import sitemap from '../views/Sitemap.vue';
import legal from '../views/Legal.vue';
import internationallocation from '../views/Internationallocation.vue';
import international from '../views/International.vue';
import event from '../views/Event.vue';
import eventsIndex from '../views/EventsIndex.vue';
import technology from '../views/Technology.vue';
import gcp from '../views/GCP.vue';
import gcpInf from '../views/GCPinf.vue';
// import gcpMig from '../views/GCPmig.vue';
import SolutionPage from '../views/SolutionPage.vue';
import DeliveryPage from '../views/DeliveryPage.vue';
import SkillingTopic from '../views/SkillingTopic.vue';
import CourseInfo from '../views/CourseInfo.vue'

import CloudDevopsServices from '../views/CloudDevopsServices';
import customers from '../views/Customers.vue';
import CustomerPage from '../views/CustomerPage.vue';
import blog from '../views/blog.vue';
//import insights from '../views/insights.vue';
import blogs from '../views/Blogs.vue';
import podcasts from '../views/Podcasts.vue';
import support from '../views/Support.vue';
import supportPage from '../views/supportPage.vue';
import skilling from '../views/Skilling.vue';
import Delivery from '../views/Delivery.vue';
import Solutions from '../views/Solutions.vue';
import contact from '../views/Contact.vue';
import careers from '../views/Careers.vue';
import team from '../views/Team.vue';
import about from '../views/About_old.vue';
import aboutnew from '../views/About.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import inTheNews from '../views/InTheNews.vue';
import stats from '../views/Stats.vue';
import guide from '../views/Guide.vue';
import CourseCatalog from '../views/CourseCatalog';
import BobTheBot from '../views/BobTheBot';
import Landing from '../views/Landing';
import RecordingsPage from '../views/RecordingsPage';
import notFound from '../views/Notfound.vue';
import NimbusDrive from '../views/static/NimbusDrive.vue';
import Ebc2025 from '../views/static/EBC2025.vue';
import Sko2025 from '../views/static/SKO2025.vue';
import { vendors, pages } from '../../localData.json';
import WhatAInight from '../views/landing/WhatAInight.vue';
import awsCXO from '../views/landing/awsCXO.vue';
import googleAI25 from '../views/landing/googleAI25.vue';
import googleotc from '../views/landing/googleotc.vue';
import geminiyacht from '../views/landing/gyacht.vue';
import githubCopilot from '../views/landing/github-copilot.vue';
import Page from '../components/Page.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: Home}, // Commented out to use _redirects file
  ...pages.map((p) => ({ path: `/solutions/${p.slug}`, name: p.name, component: Page, props: true })),
  { path: '/about', name: 'About', component: aboutnew},
  { path: '/about_old', name: 'About', component: about},
  { path: '/careers', name: 'Careers', component: careers},
  { path: '/team', name: 'Team', component: team},
  { path: '/career/:id', name: 'CareerPage', component: careerpage},
  { path: '/contact', name: 'Contact', component: contact},
  { path: '/contact/thank-you', name: 'ContactThankyou', component: contact},
  { path: '/solutions', name: 'Solutions', component: Solutions},
  { path: '/delivery', name: 'Delivery', component: Delivery},
  { path: '/skilling', name: 'Skilling', component: skilling},
  { path: '/support', name: 'Support', component: support},
  { path: '/guide', name: 'Guide', component: guide},
  { path: '/support/:slug', name: 'SupportPage', component: supportPage},
  { path: '/insights', name: 'insights', component: blogs, props: true },
  { path: '/podcasts', name: 'podcasts', component: podcasts, props: true },
  { path: '/insights/:id', name: 'blog', component: blog},
  { path: '/customers', name: 'Customers', component: customers},
  { path: '/:technology/customer-story/:slug', name: 'CustomerPage', component: CustomerPage},
  { path: '/technology', name: 'Technology', component: technology},
  ...vendors.map((v) => ({ path: `/${v.slug}`, name: v.name, component: gcp, props: true })),
  ...vendors
    .map((v) => v.pages.map((p) => ({ path: `/${v.slug}/${p.slug}`, name: p.name + v.name, component: gcpInf, props: true })))
    .flat(),
  // { path: '/google-cloud/infrastructure', name: 'GCP', component: gcpInf },
  // { path: '/google-cloud/cloud-migration', name: 'GCP', component: gcpMig },
  { path: '/events', name: 'Events-index', component: eventsIndex, props: true },
  { path: '/event/:id', name: 'Event', component: event, props: true },
  { path: '/event/:id/thank-you', name: 'EventThankyou', component: event, props: true },
  { path: '/international', name: 'International', component: international, props: true },
  { path: '/international/:id', name: 'InternationalLocation', component: internationallocation, props: true },
  { path: '/legal/:slug', name: 'Legal', component: legal, props: true },
  { path: '/sitemap', name: 'SiteMap', component: sitemap, props: true },
  { path: '/in-the-news', component: inTheNews, props: true },
  { path: '/stats', name: 'stats', component: stats, props: true },
  { path: '/coursecatalog', name: 'Courses', component: CourseCatalog, props: true },
  { path: '/bobthebot', name: 'BobTheBot', component: BobTheBot, props: true },
  { path: '/solutions/:slug', name: 'Solution', component: SolutionPage, props: true },
  { path: '/solutions/:slug/thank-you', name: 'SolutionThankyou', component: SolutionPage, props: true },
  { path: '/aws/cloud-devops', name: 'CloudDevopsServices', component: CloudDevopsServices, props: true },
  { path: '/delivery/thank-you', name: 'DeliveryThankyou', component: Delivery, props: true },
  { path: '/delivery/:slug', name: 'Delivery', component: DeliveryPage, props: true },
  { path: '/coursecatalog/:slug', name: 'Course', component: SkillingTopic, props: true },
  { path: '/coursecatalog/c/:slug', name: 'Course', component: CourseInfo, props: true },
  { path: '/graphic-maker', name: 'Graphics', component: () => import('../views/GraphicGenerator.vue'), props: true },
  { path: '/landing/:id', name: 'Landing', component: Landing, props: true },
  { path: '/rec/:id', name: 'RecPage', component: RecordingsPage, props: true },
  { path: '/what-ai-night', name: 'whatainight', component: WhatAInight, props: true },
  { path: '/aws-cxo', name: 'awscxo', component: awsCXO, props: true },
  { path: '/google-otc', name: 'googleotc', component: googleotc, props: true },
  { path: '/gyacht', name: 'geminiyacht', component: geminiyacht, props: true },
  { path: '/github-copilot', name: 'githubcopilot', component: githubCopilot, props: true },
  { path: '/nimbusdrive', name: 'NimbusDrive', component: NimbusDrive, props: true },
  { path: '/ebc2025', name: 'EBC2025', component: Ebc2025, props: true },
  { path: '/sko2025', name: 'SKO2025', component: Sko2025, props: true },
  { path: '/ai-2025', name: 'googleAI25', component: googleAI25, props: true },
  { path: '/*', name: '404', component: notFound, props: true },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash)
      return {
        behavior: 'smooth',
        selector: to.hash,
        offset: { x: 0, y: 100 },
      };
    return { y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const utm = to.query.utm_source;  // saved in registartion to events, landing pages etc
  if (utm) {
    sessionStorage.setItem('utm_source', utm);
  }
  next();
});

export default router;
